module.exports = __webpack_public_path__ + "static/img/catArduino.89783d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catArduino.svg
// module id = l8Uf
// module chunks = 0